import { State } from "./";

export interface Country {
    isoCode: string;
    isoCode3: string;
    name: string;
    phoneCode: string;
    sort: number;
    states: State[];
}

export interface ICountryInfo {
    country?: string;
    countryCode?: string;
    countryCode3?: string;
    countryPhoneCode?: string;
}

export const CountryInfoToCountry = (c: ICountryInfo): Country => {
    return {
        isoCode: c.countryCode || "",
        isoCode3: c.countryCode3 || "",
        name: c.country || "",
        phoneCode: c.countryPhoneCode || "",
        sort: 0,
        states: [],
    };
};



// WEBPACK FOOTER //
// ./src/models/country/Country.ts